import { Module } from 'vuex';
import { EmpathyXConfig, NoResultsState, QueryOrigin } from '../../models';
import { getRecommendationsModule } from '../recommendations/recommendations.module';
import { RootStoreState } from '../store.interfaces';
import { NO_RESULTS_ACTIONS } from './no-results.actions';
import { NO_RESULTS_MUTATIONS } from './no-results.mutations';
import { getInitialNoResultsState } from './no-results.state';

export function getNoResultsModule(initialConfig: EmpathyXConfig): Module<NoResultsState, RootStoreState> {
  return {
    namespaced: true,
    modules: {
      recommendations: getRecommendationsModule(initialConfig, { namespaced: false, state: { origin: QueryOrigin.noResults } })
    },
    state: getInitialNoResultsState(),
    actions: NO_RESULTS_ACTIONS,
    mutations: NO_RESULTS_MUTATIONS
  };
}
